import React from 'react';
import ContactInfo from './ContactInfo';
import logoMc from '../../assets/logo.png';
import type { BrandContact } from '@/helpers/brandLogo';

export interface FooterProps {
  /** Logo marki (brand). Domyślnie logo MotoControler. */
  logoSrc?: string;
  /**
   * Dane kontaktowe marki (telefon/e-mail) pochodzące z API. Pola, których
   * backend nie poda, nie są renderowane — nic nie zaszywamy na sztywno.
   */
  contact?: BrandContact;
}

export const Footer: React.FC<FooterProps> = ({
  logoSrc = logoMc,
  contact = {},
}) => {
  const hasPhone = !!(contact.phoneDisplay && contact.phoneHref);
  const hasEmail = !!(contact.email && contact.emailHref);

  return (
    <footer className="mt-8 w-full border-t border-[#AFC4F0] bg-white">
      <div className="container flex flex-col items-start py-8 mx-auto lg:flex-row lg:items-center">
        <img
          src={logoSrc}
          alt="Logo"
          className="mr-4 h-[36px] w-auto md:h-[56px] xl:h-[76px]"
        />
        {(hasPhone || hasEmail) && (
          <div className="flex flex-col gap-6 items-start mt-8 md:flex-row md:items-center md:justify-center md:gap-11 lg:ml-auto lg:mt-0">
            {hasPhone && (
              <ContactInfo
                title="Zadzwoń"
                value={contact.phoneDisplay!}
                href={contact.phoneHref!}
                icon="phone"
              />
            )}
            {hasEmail && (
              <ContactInfo
                title="Napisz"
                value={contact.email!}
                href={contact.emailHref!}
                icon="email"
              />
            )}
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
